export class WindowsMessage {
    constructor(payload, messageOrigin = 'BRANCH-MF') {
        this.payload = payload;
        this.messageOrigin = messageOrigin;
    }
}
//# sourceMappingURL=WindowMessage.js.map